import React from 'react';
import { useSelector } from 'react-redux';
import LocationOffline from 'components/Location/LocationOffline';
import selectLogoDestinationUrl from 'bento-ordering/base/selectors/selectLogoDestinationUrl';

const title = 'Online ordering is currently unavailable';

function LocationOfflineContainer() {
  const logoDestinationUrl = useSelector(selectLogoDestinationUrl);

  return (
    <LocationOffline logoDestinationUrl={logoDestinationUrl} title={title} />
  );
}

export default LocationOfflineContainer;
